import accordion from './modules/accordion.js'
import autocomplete from './modules/autocomplete.js'
import awardsCarousel from './modules/awards-carousel.js'
import carousel from './modules/carousel.js'
import chart from './modules/chart.js'
import cookieApproval from './modules/cookie-approval.js'
import contactLocation from './modules/contact-location.js'
import contactSelect from './modules/contact-select.js'
import countrySelect from './modules/country-select.js'
import ctaModal from './modules/cta-modal.js'
import esgInAction from './modules/esg-in-action.js'
import filter from './modules/filter.js'
import header from './modules/header.js'
import jumpLinks from './modules/jump-links.js'
import messaging from './modules/messaging.js'
import modal from './modules/modal.js'
import news from './modules/news.js'
import productCarousel from './modules/product-carousel.js'
import salesSelect from './modules/sales-select.js'
import table from './modules/table.js'
import tripsaver from './modules/tripsaver.js'

// TODO - doc ready vs window load
document.addEventListener('DOMContentLoaded', function () {

});

$(document).ready(function () {

    cookieApproval.init()

    accordion.init();
    contactLocation.init();
    contactSelect.init();
    header.init();
    jumpLinks.init();
    salesSelect.init();
    table.init();
    modal.init();
    tripsaver.init();

});
$(window).on("load", function () {

    autocomplete.init();
    filter.init();
    news.init();
    productCarousel.init();

});

// export public props (available directly on the built module - eg: sac.messaging )
export {
    awardsCarousel,
    carousel,
    chart,
    countrySelect,
    ctaModal,
    esgInAction,
    messaging
}